module.exports = __webpack_public_path__ + "img/gupy.9324a1e5.svg";